import Vue from 'vue'
import Router from 'vue-router'
import { resetPathMap, breadMap } from '@/utils/breadRouterMap'
import { getZjzwfwLoginUrlSplice } from '@/config'
import { broadcastScrollHeight } from '@/utils/broadcastScrollHeight'
import store from '../store/index'
import constantRoutes from './modules/routerModules.js'
import zscqRouterConfigs from './modules/zscqRouterModules.js'
import blockChainMoundles from './modules/blockChainMoundles.js'
import { getParamFromUrl } from '../utils/common'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}
const baseUrl = process.env.VUE_APP_BASE_ROUTER_URL || ''
const createRouter = () =>
  new Router({
    mode: 'hash',
    base: baseUrl,
    scrollBehavior: () => ({ y: 0 }),
    routes: [...constantRoutes, ...zscqRouterConfigs, ...blockChainMoundles]
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  // 在每次页面跳转前告知父级设置一个合适的高度
  broadcastFixedHeight(to.name)

  // ** 单点登录逻辑: goto统一跳转到首页，跳转之前在localStorage中缓存之前到页面地址及参数，登录完成回跳时再重定向到缓存的页面地址
  if (!['/login', '/', '/home', '/authentication'].includes(to.path)) {
    localStorage.setItem('gotoUrl', to.fullPath)
  }

  // 新访问逻辑（特定页面需要登陆）path
  if (thePathNeedLogin[to.path] && !store.state.user.ticket && !store.state.user.token) {
    if (getParamFromUrl('gxdjpersonkey') || getParamFromUrl('gxdjkey')) {
      return next()
    }

    window.location.href = getZjzwfwLoginUrlSplice()
  } else {
    return next()
  }
})

router.afterEach(to => {
  if (!to.meta) {
    return
  }
  let data = {
    title: to.meta.routeName,
    url: `https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/reserved/index.html#` + to.fullPath,
    userId: store.state?.user?.token || '',
    appid: 'fgdn_xydzjz',
    areaCode: '330000000000',
    moduleCode: '信易贷浙江站'
  }
  window.fgdn_custom_trace(data)
  // 首页和金融产品页重置面包屑
  resetBreadList(to)
})

const thePathNeedLogin = {
  '/my/loan': true,
  '/my/info': true,
  '/my/message': true,
  '/loan-detail': true,
  '/order-confirm': true
}

// 首页和金融产品页重置面包屑
function resetBreadList(to) {
  if (to.meta.resetPath) {
    return store.commit('common/SET_BREAD_LIST', resetPathMap.get(to.meta.resetPath))
  }
  if (to.name === 'login') {
    return false
  }
  const newBread = {
    routerName: to.name,
    text: breadMap.get(to.name)
  }
  let breadList = JSON.parse(JSON.stringify(store.state.common.breadList))
  const isAlreadyHas = breadList.findIndex(item => {
    return item.text === newBread.text
  })
  if (isAlreadyHas !== -1) {
    // 已经存在则表示 路由返回，删除其后面的面包屑
    breadList.splice(isAlreadyHas + 1)
    return store.commit('common/SET_BREAD_LIST', breadList)
  }
  // 未访问过的页面 添加在面包屑的最后
  breadList.push(newBread)
  store.commit('common/SET_BREAD_LIST', breadList)
}

function broadcastFixedHeight(pathName) {
  let height = 1400
  switch (pathName) {
    case 'home':
      height = 1750
      break
    case 'product':
      height = 1600
      break
    default:
      break
  }
  broadcastScrollHeight(height)
}

export default router
